let store = require("../store");
let actions = require("../actions");

let FormControls = mc.widgets.FormControls;
let FormFeedback = mc.widgets.FormFeedback;

class StudyFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      study: mc.utils.clone(this.props.study) || {
        displayName: "",
        title: "",
        description: "",
        accountId: store.getState().accountId,
        lifecycleState: "INITIALIZED"
      },
      errors: [],
      submitting: false
    };
  }

  setDisplayName(evt) {
    let study = { ...this.state.study, displayName: evt.target.value };

    this.setState({ study });
  }

  setTitle(evt) {
    let study = { ...this.state.study, title: evt.target.value };

    this.setState({ study });
  }

  isValid() {
    let study = this.state.study;

    return study.displayName.trim().length > 0 && study.title.trim().length > 0;
  }

  saveStudy() {
    let study = this.state.study;
    let method = study.id ? "UPDATE" : "CREATE";

    actions.saveStudy(study, method).then((function (payload) {
      if (payload.errors.length) {
        this.setState({
          errors: payload.errors,
          submitting: false
        });
      }
      else {
        if (method === "CREATE") {
          mc.router.trigger("DESIGN_STUDY_VIEW", { studyId: payload.study.id });
        }

        if (method === "UPDATE") {
          mc.ui.modal(null);
        }
  
        actions.loadStudies(store.getState().accountId);
      }
    }).bind(this));

    this.setState({
      submitting: true
    });
  }

  deleteStudy() {
    let study = mc.utils.clone(this.state.study);
    study.isArchived = true;

    mc.ui.alert(tx("delete_study"), {
      level: "warn",
      mode: "confirm",
      labels: {
        confirm: tx("delete"),
        cancel: tx("cancel")
      },
      onHide: (function (confirmed) {
        if (confirmed) {
          actions.saveStudy(study, "DELETE").then((function (payload) {
            if (payload.errors.length) {
              this.setState({
                errors: payload.errors,
                submitting: false
              });
            }
            else {
              mc.router.trigger("LOGIN_VIEW");
            }
          }).bind(this));

          this.setState({
            submitting: true
          });
        }
      }).bind(this)
    });
  }

  cancel() {
    mc.ui.modal(null);
  }

  static open(study) {
    let dismissable = study && study.lifecycleState !== "INITIALIZED";

    mc.ui.modal(<StudyFormView study={study}/>, { width: "60%", dismissable });
  }

  render() {
    let study = this.state.study;
    let disabled = study.lifecycleState !== "INITIALIZED";

    return (
      <div className="rc-study-form-view">
        <h1>{study.id ? (study.displayName || "...") : tx("new_study")}</h1>
        <div>
          <div className="mc-form">
            <div className="mc-form-row">
              <div className="mc-form-label">{tx("study_id")}</div>
              <input
                disabled={disabled}
                name="displayName"
                type="text"
                size="20"
                maxLength="20"
                value={study.displayName}
                onChange={this.setDisplayName.bind(this)}/>
            </div>
            <div className="mc-form-row">
              <div className="mc-form-label">{tx("description")}</div>
              <textarea
                disabled={disabled}
                name="title"
                rows="5"
                cols="40"
                maxLength="1024"
                value={study.title}
                onChange={this.setTitle.bind(this)}/>
            </div>
          </div>
          <FormFeedback errors={this.state.errors}/>
          <FormControls
            onSave={this.saveStudy.bind(this)}
            onCancel={this.cancel.bind(this)}
            onDelete={(study.id && store.getState().studies.length > 1) && this.deleteStudy.bind(this)}
            enabled={this.isValid() && !this.state.submitting && !disabled}/>
        </div>
      </div>
    );
  }
}

module.exports = StudyFormView;